import React from "react";
import { Item } from "./item";
import { Box, Typography } from "@material-ui/core";

interface MenuProps {
  children?: React.ReactElement<typeof Item>[];
}

export const Menu: React.FC<MenuProps> = ({ children }) => {
  return (
    <Typography variant="body2" component="nav" role="navigation">
      <Box component="ul" display="flex" m={0} p={0}>
        {children}
      </Box>
    </Typography>
  );
};
